module.exports = __webpack_public_path__ + "img/img11.26ef0b38.svg";